import {Flex, Icon, ListItem, PriorityIcon, Text} from '@priority-software/priority-style-react';
import React from 'react';
import {MacroMenuDropdown} from '../../Macros/MacroMenuDropdown';
import {useHover} from '../../../../../hooks/useHover';
import {OldMacroSubMenu} from './OldMacroSubmenu';
import {AutomationSettingsItem, macroItem} from '../constants';

type Props = {
    isOpenSubmenu: boolean;
    index: number;
    currentFocusedIndex: number;
    handleShowHelp: (e, desc: string) => void;
    handleOpenSubMenu: () => void;
    openMacro: (item: AutomationSettingsItem) => void;
    handleClose: () => void;
    closeSubMenu: () => void;
    useBridgeAPI: boolean;
};

export const MacroItem = ({
    isOpenSubmenu,
    index,
    currentFocusedIndex,
    handleShowHelp,
    handleOpenSubMenu,
    openMacro,
    handleClose,
    closeSubMenu,
    useBridgeAPI
}: Props) => {
    const {setRef, isHovering} = useHover();

    return (
        <ListItem
            key={macroItem.title}
            ref={setRef}
            onClick={handleOpenSubMenu}
            isFocused={currentFocusedIndex === index}
            componentClasses="ignore-react-onclickoutside"
            isActive={false}
        >
            {!useBridgeAPI ? (
                <Flex justifyContent="space-between">
                    <Flex justifyContent="flex-start">
                        <Text tag="div" skin="paragraph-1">
                            {macroItem.title}
                        </Text>
                        {isHovering && (
                            <Icon
                                icon={PriorityIcon.help}
                                onClick={e => handleShowHelp(e, macroItem.desc)}
                            />
                        )}
                    </Flex>
                    <MacroMenuDropdown
                        isOpen={isOpenSubmenu}
                        openMacro={openMacro}
                        closeSubMenu={handleOpenSubMenu}
                    />
                </Flex>
            ) : (
                <OldMacroSubMenu
                    isSubmenuOpen={isOpenSubmenu}
                    handleClose={handleClose}
                    handleCloseSubMenu={closeSubMenu}
                    isHovering={isHovering}
                    useBridgeAPI={useBridgeAPI}
                    handleShowHelp={handleShowHelp}
                />
            )}
        </ListItem>
    );
};
